export default "__VITE_ASSET__04b1b030__"